import {
	type UseMutationOptions,
	useMutation,
	useQueryClient
} from '@tanstack/react-query'
import {
	type HttpUpdateOfferingMainPhotoProPhotos,
	httpUpdateOfferingMainPhotoProPhotos
} from '@/features/service-vetting/http/services-vetting.http.ts'
import { errorHandler } from '@/helpers/utils'
import { QUERY_KEYS } from '@/query-client'

export const useUpdateMainPhotoOfferingProPhoto = (
	urlParams: Omit<HttpUpdateOfferingMainPhotoProPhotos['urlParams'], 'imgId'>,
	options?: UseMutationOptions<unknown, unknown, { coverImageId: number }>
) => {
	const queryClient = useQueryClient()
	return useMutation({
		...options,
		mutationFn: (payload) =>
			httpUpdateOfferingMainPhotoProPhotos({
				urlParams: { ...urlParams },
				params: {
					responseType: 'small'
				},
				payload: { coverImageId: payload.coverImageId }
			}),
		onError: (error, variables, onMutateResult, context) => {
			errorHandler(error)
			options?.onError?.(error, variables, onMutateResult, context)
		},
		onSuccess: (data, variables, onMutateResult, context) => {
			queryClient.invalidateQueries({
				queryKey: [
					QUERY_KEYS.SERVICE_GALLERY_IMAGES_PRO_PHOTOS,
					urlParams.serviceId
				]
			})
			queryClient.invalidateQueries({
				queryKey: [QUERY_KEYS.SERVICE_PRO_PHOTOS, urlParams.serviceId]
			})
			options?.onSuccess?.(data, variables, onMutateResult, context)
		}
	})
}
